"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTextCompact = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const smartlabel_1 = __importDefault(require("../../smartlabel/smartlabel"));
const textinput_1 = __importDefault(require("../../textinput/textinput"));
const status_1 = require("../../constants/status");
class FieldTextCompact extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            inputHasFocus: false
        };
        this.id = lodash_uniqueid_1.default('ftc_');
        this.handleFocus = e => {
            this.props.onFocus(e);
            this.setState({
                inputHasFocus: true
            });
        };
        this.handleBlur = e => {
            this.props.onBlur(e);
            this.setState({
                inputHasFocus: false
            });
        };
        this.handleChange = e => {
            this.props.onValueChange(e);
        };
        this.render = () => {
            const { label, value, inputRef, disabled, invalid, caution, valid, modified, required, hideLabel, addClear, dataCy } = this.props;
            const { inputHasFocus } = this.state;
            let status;
            if (invalid) {
                status = status_1.STATUS_INVALID;
            }
            else if (caution) {
                status = status_1.STATUS_CAUTION;
            }
            else if (valid) {
                status = status_1.STATUS_VALID;
            }
            else if (modified) {
                status = status_1.STATUS_MODIFIED;
            }
            else {
                status = null;
            }
            const labelProps = {
                forId: this.id,
                text: label,
                inputHasValue: !!value,
                inputHasFocus,
                status,
                required,
                hideLabel
            };
            const inputProps = {
                type: addClear ? 'search' : 'text',
                placeholder: label,
                id: this.id,
                handleFocus: this.handleFocus,
                handleBlur: this.handleBlur,
                handleChange: this.handleChange,
                value,
                inputRef,
                status,
                disabled,
                dataCy
            };
            return (jsx_runtime_1.jsx(smartlabel_1.default, Object.assign({}, labelProps, { children: jsx_runtime_1.jsx(textinput_1.default, Object.assign({}, inputProps), void 0) }), void 0));
        };
    }
}
exports.FieldTextCompact = FieldTextCompact;
FieldTextCompact.propTypes = {
    label: prop_types_1.default.string.isRequired,
    onValueChange: prop_types_1.default.func.isRequired,
    inputRef: prop_types_1.default.func,
    value: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    caution: prop_types_1.default.bool,
    valid: prop_types_1.default.bool,
    modified: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    hideLabel: prop_types_1.default.bool,
    addClear: prop_types_1.default.bool,
    onFocus: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    dataCy: prop_types_1.default.string
};
FieldTextCompact.defaultProps = {
    inputRef: () => { },
    value: '',
    disabled: false,
    invalid: false,
    caution: false,
    valid: false,
    modified: false,
    required: false,
    hideLabel: false,
    addClear: false,
    onFocus: () => { },
    onBlur: () => { },
    dataCy: 'atomic-fieldtext-compact'
};
exports.default = FieldTextCompact;
//# sourceMappingURL=field.text.compact.js.map